/**
 * Global constants. You can define your constant and access it by importing this file in the component.
 */
export const AppGlobals = {
    GOOGLE_CLIENT_ID: ''
}


// WEBPACK FOOTER //
// ./~/angular2-google-login/src/app-globals.ts